import React, { Fragment, useContext, useEffect, useState } from 'react';
import {
	getTranslation,
	useCustomTranslation,
} from '../../hooks/useTranslations';

import CompanyItem from '../../containers/Company/Components/companyItem';
import { CompanyRelatedContext } from '../../context/CompanyRelatedContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IsNullOrEmpty } from '../../utils';
import { StoreContext } from '../../business/Provider';
import { ToolBarNames } from '../../translations';
import { Tooltip } from 'primereact/tooltip';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import useCompanies from '../../hooks/Company/useCompany';
import useReload from '../../hooks/useReload';
import { useSelector } from 'react-redux';

export const CompanyInfo = ({
	refCloseCompanyInfo,
	showCompanyInfo,
	setShowCompanyInfo,
}) => {
	const { companyState } = useContext(StoreContext);
	const { t } = useCustomTranslation();
	const user = useSelector(({ auth }) => auth.user);
	// const [showCompanyInfo, setShowCompanyInfo] = useState(false);
	const { currentCompany } = useCompanies();
	const { relatedCompanies } = useContext(CompanyRelatedContext);
	const getRFCFromSession = () => {
		const sessionStateStorage = sessionStorage.getItem('sessionState');
		const sessionObj = JSON.parse(sessionStateStorage);
		document.title = sessionObj
			? (sessionObj?.rfc || '') + ' | ' + ' CONTPAQi� Evalua'
			: 'CONTPAQi� Evalua';
		return sessionObj?.rfc || '';
	};
	//useReload([getRelatedCompanies])
	const onGetRelatedCompanies = async () => {
		setShowCompanyInfo(!showCompanyInfo);
	};
	const renderCompanyRelatedItemsNavBar = () => {
		return (
			<div className='flex w-[30px] h-16 justify-around'>
				<div
					className='flex h-full w-5/12'
					title={getTranslation(t, ToolBarNames.COMPANY_RELATED)}>
					<Fragment key={'companyRelated'}>
						<div
							key={'companyRelated'}
							onClick={onGetRelatedCompanies}
							className={`tooltip-companyRelated flex-grow flex text-[#5e5e5e]  items-center content-center justify-center cursor-pointer hover:text-[#0a6ebd] hover:bg-[#5e5e5e1e]`}>
							<FontAwesomeIcon icon={faLink} />
						</div>
					</Fragment>
				</div>
			</div>
		);
	};

	useEffect(() => {
		let isMounted = true; 
	
		const token = localStorage.getItem('accessToken');
		if (!token) return;
	
		function parseJwt(token) {
			try {
				const base64Url = token.split('.')[1];
				const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
				const jsonPayload = decodeURIComponent(
					window
						.atob(base64)
						.split('')
						.map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
						.join('')
				);
				return JSON.parse(jsonPayload);
			} catch (e) {
				console.error('Error al parsear token JWT:', e);
				return {};
			}
		}
	
		if (companyState?.companies && typeof companyState.companies === 'object') {
			localStorage.setItem(
				'companyInfo',
				JSON.stringify(companyState?.companies));

			const dataInfo = parseJwt(token);
	
			const origen = window.REACT_APP_CHATBOT_ORIGEN;
			const emailUser = dataInfo.email || '';
			const userName = `${dataInfo.given_name || ''} ${dataInfo.family_name || ''} ${dataInfo.extension_family_second_name || ''}`.trim();
			const accountNumber = dataInfo.extension_LicenseCode || '';
			const nivel = window.REACT_APP_CHATBOT_LEVEL
	
			const onReady = () => {
				if (!isMounted) return; // se cancela si ya no est� montado
				embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
					origen,
					emailUser,
					userName,
					accountNumber,
					nivel,
					timestamp: new Date().toISOString(),
				});
			};
	
			window.addEventListener('onEmbeddedMessagingReady', onReady);

			const baseUrl = `${document.location.protocol}${window.REACT_APP_CHATBOT_CHATBOTURL}`;
	
			window.initEmbeddedMessaging = function () {
				if (!isMounted) return;
				try {
					embeddedservice_bootstrap.settings.language = 'es_MX';
					embeddedservice_bootstrap.settings.chatButtonPosition = '30px,calc(100vw - 80px)';
	
					embeddedservice_bootstrap.init(
						window.REACT_APP_CHATBOT_ORGANIZATIONID,
						window.REACT_APP_CHATBOT_DEPLOYMENT_NAME,
						baseUrl,
						{ 
							scrt2URL: document.location.protocol + window.REACT_APP_CHATBOT_SRCT2URL 
						}
					);
				} catch (err) {
					console.error('Error loading Embedded Messaging: ', err);
				}
			};
	
			const script = document.createElement('script');
			script.id = 'sf-chat-script';
			script.type = 'text/javascript';
			script.async = true;
			script.src = `${baseUrl}/assets/js/bootstrap.min.js`;
			script.onload = () => {
				if (isMounted) window.initEmbeddedMessaging();
			};
	
			document.head.appendChild(script);
		}
	
		// Cleanup
		return () => {
			isMounted = false;
			window.removeEventListener('onEmbeddedMessagingReady', () => {});
		};
	}, [companyState]);

	return (
		<>
			<div className='flex flex-col h-full w-4  font-h2-alt-font-family text-secondary-contrast-color-text pt-3'>
				{currentCompany && relatedCompanies && relatedCompanies.length > 0 ? (
					renderCompanyRelatedItemsNavBar()
				) : (
					<></>
				)}
			</div>
			<div
				ref={refCloseCompanyInfo}
				className='flex flex-col h-full w-full  font-h2-alt-font-family text-secondary-contrast-color-text pt-3 ml-2'>
				<div className='flex w-full font-bold  text-[#01b0f3] text-small-font-size '>
					{/*<p className='leading-3'>{getRFCFromSession()}</p>*/}
					<p className='leading-3'>
						{companyState?.companies?.taxID
							? companyState?.companies.taxID
							: getRFCFromSession()}
					</p>
				</div>
				<div
					title={currentCompany?.name}
					className='flex w-full  text-sm truncate'>
					{currentCompany ? currentCompany.name : ''}
				</div>
				<div className='flex w-full  text-xs'>
					{currentCompany ? currentCompany.alias : ''}
				</div>
			</div>
			{showCompanyInfo ? (
				<ul className='flex min-w-max flex-col pt-1 absolute top-[4rem] divide-y rounded-md bg-dropdown-bg-default drop-shadow-2xl  '>
					{relatedCompanies &&
						relatedCompanies.map((item, index) => {
							return (
								<li key={index}>
									{/* <ButtonDropDown key={index} className='h-12 w-full p-2 !font-h3-font-family' title={item.text}  />  */}

									<CompanyItem item={item} className='mx-1'></CompanyItem>
								</li>
							);
						})}
				</ul>
			) : (
				<></>
			)}
		</>
	);
};
